import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { getLatestPosts } from 'actions/posts.action'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/translationKeys'

export interface LatestPostsProps {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useLatestPosts = (props: LatestPostsProps) => {
  const dispatch = useAppDispatch()
  const latestPosts = useSelector(
    (state: RootState) => state.posts.latestPostsData
  )

  useEffect(() => {
    if (!latestPosts) dispatch(getLatestPosts())
  }, [latestPosts])

  return {
    ...props,
    latestPosts,
  }
}
